import React, { useRef } from 'react';
import useAnalyticsActionOnScroll from '../../../hooks/useAnalyticsActionOnScroll';

type TAnalyticsVisibleEvent = {
  children: any;
  rendering: any;
  title: any;
  template: any;
  className?: string;
  styles?: any;
};

const AnalyticsVisibleEvent = (props: TAnalyticsVisibleEvent) => {
  const { children, rendering, title, template, className, styles } = props;
  const elementRef = useRef<HTMLDivElement | null>(null);

  useAnalyticsActionOnScroll(rendering, elementRef, title, template);

  return (
    <div className={className} ref={elementRef} style={{ ...styles }}>
      {children}
    </div>
  );
};

export default AnalyticsVisibleEvent;
